<form [formGroup]="form">
  <rask-search
    aid="anvandarNamn"
    class="col-3"
    label="Visa händelser för"
    bindLabel="namn"
    bindValue="id"
    formControlName="sokTypeAhead"
    typeToSearchText="Sök användarnamn"
    loadingText="Laddar..."
    notFoundText="Ingen träff"
    [minTermLength]="3"
    [typeaheadFn]="searchAnvandareTypeAhead"
    [selected]="form.value.sokTypeAhead"
    (change)="getHandelser($event)">
  </rask-search>

  @for (item of filters; track item) {
    <rask-checkbox
      [text]="item.text"
      [(ngModel)]="item.selected"
      (change)="filter()"
      [ngModelOptions]="{standalone: true}">
    </rask-checkbox>
  }

  <div class="list-container">
    @if (!!(handelser?.length)) {
      <rask-list [data]="filteredHandelser$ | async">
        <rask-list-column header="" field="severity" [sortable]="true" width="25px">
          <ng-template let-row="row">
            <i class="far" [ngClass]="messageIconClass(row.severity)"></i>
          </ng-template>
        </rask-list-column>
        <rask-list-column header="Händelse" field="message" [sortable]="true" width="400px"></rask-list-column>
        <rask-list-column header="Arbetsorder" field="linkName" [sortable]="true" width="300px">
          <ng-template let-row="row">
            @if (row.isArbetsorder) {
              <a href="planera/{{row.id}}">{{row.linkName}}</a>
            }
            @for (arbetsorder of row.relatedArbetsordrar; track arbetsorder) {
              <a href="planera/{{arbetsorder.id}}">{{arbetsorder.linkName}}<br></a>
            }
          </ng-template>
        </rask-list-column>
        <rask-list-column header="Avtal/Kontrakt" field="linkName" [sortable]="true" width="300px">
          <ng-template let-row="row">
            @if (!row.isArbetsorder && row.subEntityId === null) {
              <a [routerLink]="['virkeskop/anbudkontrakt/', row.id]">{{row.linkName}}</a>
            }
            @if (!row.isArbetsorder && row.subEntityId !== null && row.subEntityType === 'Kontrakt') {
              <a [routerLink]="['virkeskop/avtal/', row.id]" [queryParams]="{kontraktId : row.subEntityId}">{{getLinkName(row.linkName, row.subEntityLinkName)}}</a>
            }
          </ng-template>
        </rask-list-column>
        <rask-list-column header="Inträffade" field="errorDate" [sortable]="true" width="170px"></rask-list-column>
        <rask-list-column header="Produktionsstatus" field="aoStatus" [sortable]="true" width="200px">
        </rask-list-column>
        <rask-list-column header="Schemalagd" field="scheduled" [sortable]="true" width="130px"></rask-list-column>
      </rask-list>
    }

    @if (!(handelser?.length)) {
      <div>Hittade inga händelser</div>
    }
  </div>
</form>
